module.exports = __webpack_public_path__ + "img/icon13.636f42be.png";